import { withPrefix } from "gatsby"

export const formatURLToGetChartShareLink = (location, chartId) => {
  if (!location) {
    return '';
  }

  return location.origin + withPrefix(`report/chart/${chartId}/`);
};
